import { __decorate } from "tslib";
import moment from 'moment';
import lang from '@blade-sxp/portrait-management/lang/index';
import colors from '@/styles/color.scss';
import importModule from '@blade-sxp/portrait-management/pages/components/import-module.vue';
import InputSearch from '@blade-sxp/portrait-management/components/input-search.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getImportList, againUpload } from '@blade-sxp/portrait-management/api/portrait';
import { PageOrderEnum, LibraryTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { AlarmWebsocket as PhotoWebsocket } from '@blade/common/utils/websocket';
import { EPhotoStatus } from '@blade/common/interfaces/upload';
import { Scale } from '@blade/common/utils/auto-scale';
const { zh, en } = lang;
let default_1 = class default_1 extends Vue {
    funnelIcon = require('@blade-sxp/task-management/assets/union.png');
    defaultSort = { prop: 'updateTime', order: 'descending' };
    defaultPageSize = [10, 20, 50, 100, 200];
    defaultTableMinWidth = {
        fileName: 184 * Scale,
        createdBy: 180 * Scale,
        updatedAt: 180 * Scale,
        validAll: 140 * Scale,
        state: 140 * Scale,
        reasonOfFailure: 200 * Scale,
        action: 94 * Scale,
    };
    cellBackground = colors.colorBoxBg;
    lineFillStyle = colors.lineFillStyle;
    keyword = '';
    pagination = {
        page: 1,
        size: 10,
        total: 0,
        state: undefined,
    };
    tableLoading = false;
    tableList = [];
    filterLibraryStatus = [];
    tableBtnLoading = {};
    libType = LibraryTypeEnum.PORTRAIT_LIBRARY;
    loadingCloseTimeoutId = undefined;
    upWS;
    upWSurl = this.mapUrl();
    initI18n() {
        this.filterLibraryStatus = [
            { text: String(this.$t('uploadCompleted')), value: 'UPLOAD_COMPLETED' },
            { text: String(this.$t('successed')), value: 'PROCESS_COMPLETED' },
            { text: String(this.$t('processWaiting')), value: 'PROCESS_WAITING' },
            { text: String(this.$t('uploadFailed')), value: 'UPLOAD_INTERRUPTED' },
            { text: String(this.$t('processInterrupted')), value: 'PROCESS_INTERRUPTED' },
            { text: String(this.$t('uploading')), value: 'UPLOADING' },
            { text: String(this.$t('processing')), value: 'PROCESSING' },
            { text: String(this.$t('processFailed')), value: 'PROCESS_FAILED' },
        ];
    }
    created() {
        this.$router.onReady(async () => {
            const query = this.$route.query;
            this.libType = query.libType;
        });
    }
    mounted() {
        this.getList();
        this.initWebsocket();
        this.initI18n();
    }
    onSearch() {
        this.pagination.page = 1;
        this.getList();
    }
    // 当选择项发生变化时会触发该事件
    handleSelectionChange(selection) {
        console.log(selection);
        this.getList();
    }
    // 当表格的筛选条件发生变化的时候会触发该事件
    handleFilterChange(e) {
        console.log(e);
        if (e.state && e.state instanceof Array && e.state.length > 0)
            this.pagination.state = e.state[0];
        else
            this.pagination.state = undefined;
        this.getList();
    }
    sortChange(order) {
        this.pagination.pageOrderList = [
            {
                orderField: 'updateTime',
                orderType: order.order === 'ascending' ? PageOrderEnum.ASC : PageOrderEnum.DESC,
            },
        ];
        this.getList();
    }
    // pageSize 改变时会触发
    handleSizeChange(e) {
        this.pagination.size = e;
        this.getList();
    }
    // currentPage 改变时会触发
    handleCurrentChange(e) {
        this.pagination.page = e;
        this.getList();
    }
    getParams() {
        return {
            fileName: this.keyword,
            page: this.pagination.page,
            size: this.pagination.size,
            state: this.pagination.state,
            pageOrderList: this.pagination.pageOrderList,
        };
    }
    // 获取table list
    getList() {
        this.tableLoading = true;
        const params = this.getParams();
        clearTimeout(this.loadingCloseTimeoutId);
        try {
            getImportList(params)
                .then((res) => {
                console.log('列表：', res);
                const { list, total } = res;
                this.tableList = list;
                this.pagination.total = total;
            })
                .finally(() => {
                this.tableLoading = false;
            });
        }
        catch (error) {
            console.log('getList err', error);
            this.tableLoading = false;
        }
    }
    // table 内的状态判断
    getReUploadStatus(state) {
        return state !== 'PROCESS_COMPLETED' && state !== 'UPLOAD_COMPLETED';
    }
    // 重新上传
    onReUpload(row) {
        console.log('重新上传', row);
        this.tableBtnLoading[row.taskId] = true;
        this.tableBtnLoading = { ...this.tableBtnLoading };
        againUpload(row.taskId)
            .then((res) => {
            this.$message({
                customClass: 'success-message',
                message: this.$t('reUploadSuccess'),
                type: 'success',
                showClose: true,
            });
            this.getList();
        })
            .finally(() => {
            this.tableBtnLoading[row.taskId] = false;
            this.tableBtnLoading = { ...this.tableBtnLoading };
        });
    }
    // 上传成功
    onUploadSuccess() {
        this.onSearch();
    }
    onDetails(row) {
        console.log(row);
        this.$router.push({
            name: this.libType === LibraryTypeEnum.PORTRAIT_LIBRARY ? 'portraitRecords' : 'vehicleRecords',
            query: Object.assign({}, this.$route.query, {
                taskId: row.taskId,
            }),
        });
    }
    // 格式化时间
    formatDate(time) {
        return moment(new Date(time)).format('yyyy-MM-DD HH:mm:ss');
    }
    // 格式化状态
    getStatusText(state) {
        return this.filterLibraryStatus.find((a) => a.value === state)?.text ?? '';
    }
    mapUrl() {
        const res = process.env.NODE_ENV === 'development'
            ? process.env.VUE_APP_UPLOAD_WS
            : `wss://${window.location.host}/${process.env.VUE_APP_UPLOAD_WS}`;
        return res || '';
    }
    mapState(status) {
        switch (status) {
            case EPhotoStatus.UPLOAD_INTERRUPTED:
                return this.$t('error');
            case EPhotoStatus.PROCESS_COMPLETED:
                return this.$t('success');
            case EPhotoStatus.UPLOADING:
            case EPhotoStatus.UPLOAD_COMPLETED:
            case EPhotoStatus.PROCESS_WAITING:
            case EPhotoStatus.PROCESSING:
                return this.$t('uploading');
        }
    }
    initWebsocket() {
        this.upWS = new PhotoWebsocket(this.upWSurl);
        this.upWS.setOnMessage(this.websocketonmessage);
    }
    websocketonmessage(e) {
        let socList = [];
        socList.push(JSON.parse(e.data));
        socList.forEach((item) => {
            const num = this.tableList.findIndex((son) => {
                return item.taskId === son.taskId;
            });
            this.$set(this.tableList, num, item);
        });
    }
    destroyed() {
        this.upWS && this.upWS.close();
    }
};
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        i18n: {
            messages: {
                en: {
                    batchImportRecord: 'Batch Import Record',
                    portraitFileName: 'File Name',
                    successed: 'Successed',
                    uploadFailed: 'Upload Failed',
                    processInterrupted: 'Process Interrupted',
                    uploading: 'Uploading',
                    processFailed: 'Process Failed',
                    reUpload: 'Re-upload',
                    reUploadSuccess: 'Re-upload Success',
                    processWaiting: 'Process Waiting',
                    uploadCompleted: 'Upload Completed',
                    processing: 'Processing',
                    ...en,
                },
                zh: {
                    batchImportRecord: '批量导入记录',
                    portraitFileName: '文件名',
                    successed: '上传入库成功',
                    uploadFailed: '上传错误',
                    processInterrupted: '入库中断',
                    uploading: '上传中',
                    processFailed: '入库错误',
                    reUpload: '重新上传',
                    reUploadSuccess: '重新上传成功',
                    processWaiting: '上传完成待处理',
                    uploadCompleted: '上传完成',
                    processing: '处理中',
                    ...zh,
                },
            },
        },
        components: { importModule, InputSearch },
    })
], default_1);
export default default_1;
